import React from 'react';
import { Form, Pagination } from 'react-bootstrap';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

interface Props {
  totalCount: number;
  limit: number;
  currentPage: number;
  setPage: (page: number) => void;
  setLimit: (limit: number) => void;
}

const CustomPagination: React.FC<Props> = ({ totalCount, limit, currentPage, setPage, setLimit }) => {
  const totalPages = Math.ceil(totalCount / limit);

  const renderPaginationItems = () => {
    const items = [];

    const maxVisible = 4; // Maximum number of visible page items
    const startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(totalPages, startPage + maxVisible - 1);

    if (startPage > 1) {
      items.push(
        <Pagination.Item key={1} onClick={() => setPage(1)} active={1 === currentPage}>
          1
        </Pagination.Item>
      );
      if (startPage > 2) items.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
    }

    for (let page = startPage; page <= endPage; page++) {
      if (page !== 1 && page !== totalPages) {
        items.push(
          <Pagination.Item
            key={page}
            active={page === currentPage}
            onClick={() => setPage(page)}
          >
            {page}
          </Pagination.Item>
        );
      }
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) items.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
      items.push(
        <Pagination.Item key={totalPages} onClick={() => setPage(totalPages)} active={currentPage === totalPages}>
          {totalPages}
        </Pagination.Item>
      );
    }

    return items;
  };

  if (totalPages <= 1) return null;

  return (
    <div className="p-3" style={{ borderTop: '1px solid #444' }}>
      <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap gap-2">
        <small style={{ color: '#999' }}>
          Showing {(currentPage - 1) * limit + 1} to {Math.min(currentPage * limit, totalCount)} of {totalCount} conversations
        </small>
        <Form.Select 
          size="sm" 
          value={limit}
          onChange={(e) => setLimit(Number(e.target.value))}
          style={{ backgroundColor: '#444', borderColor: '#555', color: '#fff', width: 'auto' }}
        >
          <option value={10}>10 per page</option>
          <option value={20}>20 per page</option>
          <option value={50}>50 per page</option>
          <option value={100}>100 per page</option>
        </Form.Select>
      </div>

      <Pagination size="sm" className="mb-0 justify-content-center flex-wrap">
        <Pagination.Prev
          onClick={() => setPage(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <FaChevronLeft />
        </Pagination.Prev>

        {renderPaginationItems()}

        <Pagination.Next
          onClick={() => setPage(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          <FaChevronRight />
        </Pagination.Next>
      </Pagination>
    </div>
  );
};

export default CustomPagination;
